export default function Users() {
  return <div className="p-6 text-2xl">Users Screen</div>;
}